import {get} from 'lib/fetch';
import {SessionRuntype} from '../model';

export async function LoadSessionAPI() {
    return await get({url: 'session'}, SessionRuntype);
}
